

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import type { User } from '@/models/user';

import GlobalSubPhasesList from '@/components/knowledge/globals/GlobalSubPhasesList.vue';
import SearchField from '@/components/prine/SearchField.vue';
import type { GlobalPMSubPhase } from '@/models/pmsubphase';
import type { PMLesson } from '@/models/pmlesson';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'GlobalSubPhases',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        GlobalSubPhasesList,
        SearchField,
    },
})
export default class GlobalSubPhases extends Vue {
    private globals = new Array<GlobalPMSubPhase>();
    private isSearching: boolean = false;
    private searchQuery: string = '';
    private filterByLessons: boolean = hasPermission(PERMISSIONS.APPEX_PM_LESSON);

    private isLoaded: boolean = false;
    private isLoading: boolean = false;
    private tableSettings = {
        openedDetailed: Array<number>(),
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };

    @Getter('account/userInfo') private userInfo: User;
    @Prop() private globalSubPhases: GlobalPMSubPhase[];
    @Prop() private editMode: boolean;

    @Watch('globalSubPhases')
    private onGlobalSubPhasesChange() {
        this.prepareData();
    }

    @Watch('searchQuery')
    private onSearchQueryValueChange() {
        this.search();
    }

    private mounted() {
        this.prepareData();
    }

    private updateSearchQuery(value: string) {
        this.searchQuery = value;
    }

    private search() {
        this.isSearching = true;

        const regExQuery = new RegExp(this.searchQuery.trim(), 'i');

        let originalGlobalSubPhases: GlobalPMSubPhase[];
        originalGlobalSubPhases = JSON.parse(JSON.stringify(this.globalSubPhases));

        this.globals = originalGlobalSubPhases.filter((global: GlobalPMSubPhase) => {
            const titleMatch = global.title.search(regExQuery) !== -1;

            if (this.filterByLessons) {
                const filteredLessons = global.lessons.filter((lesson: PMLesson) => {
                    return lesson.insight.search(regExQuery) !== -1;
                });
                global.lessons = filteredLessons;
                global.lessons_count = filteredLessons.length;
                return titleMatch || global.lessons.length > 0;
            } else {
                return titleMatch;
            }
        });

        this.isSearching = false;
    }

    private async prepareData() {
        this.globals = JSON.parse(JSON.stringify(this.globalSubPhases));
        this.isLoaded = true;
        if (this.$route.query.searchQuery && this.$route.query.searchQuery !== '') {
            this.searchQuery = decodeURIComponent(this.$route.query.searchQuery.toString());
            if (this.$route.query.filterByLessons) {
                this.filterByLessons = this.$route.query.filterByLessons === 'true';
            }
        }
    }

    private rowClicked(global: GlobalPMSubPhase) {
        if (hasPermission(PERMISSIONS.APPEX_PM_LESSON)) {
            this.$router.push({
                path: '/knowledge/globalSubPhases/detailed',
                query: {
                    // sub_phases_ids: global.sub_phases_ids.toString(),
                    sq: this.searchQuery,
                    fbl: this.filterByLessons.toString(),
                    title: encodeURIComponent(global.title),
                },
            });
        }
    }

    private clearSearch() {
        // Reset the search query
        this.searchQuery = '';
    }
}
